import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import {
  confidentialInfoQuiz,
  confidentialInfoSlides,
} from "@/constants/confidential";

const ConfidentialInfo: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={confidentialInfoSlides}
      quizName={SecurityTopicEnum.ConfidentialInfo}
      quizList={confidentialInfoQuiz}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default ConfidentialInfo;
